// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:xTQiGM */\n.AK-P5{grid-gap:var(--audio-spacing-48);display:grid;gap:var(--audio-spacing-48);grid-template-columns:1fr;padding-top:var(--audio-spacing-16)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": "AK-P5"
};
export default ___CSS_LOADER_EXPORT___;
